module.exports = __webpack_public_path__ + "static/media/cybercrime@2x.c2a305a6.png";